// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { DrugsState } from '../_reducers/drug.reducers';
import { Drug } from '../_models/drug.model';

export const selectDrugsState = createFeatureSelector<DrugsState>('drugs');

export const selectDrugById = (drugId: number) =>
  createSelector(selectDrugsState, (drugsState) => drugsState.entities[drugId]);

export const selectDrugsPageLoading = createSelector(selectDrugsState, (drugsState) => {
  return drugsState.listLoading;
});

export const selectDrugsActionLoading = createSelector(
  selectDrugsState,
  (drugsState) => drugsState.actionsloading,
);

export const selectLastCreatedDrugId = createSelector(
  selectDrugsState,
  (drugsState) => drugsState.lastCreatedDrugId,
);

export const selectLastCreatedDrug = createSelector(
  selectDrugsState,
  (drugsState) => drugsState.lastCreatedDrug,
);

export const selectDrugsPageLastQuery = createSelector(
  selectDrugsState,
  (drugsState) => drugsState.lastQuery,
);
export const selectDrugError = createSelector(selectDrugsState, (drugsState) => drugsState.error);
export const selectDrugLatestSuccessfullAction = createSelector(
  selectDrugsState,
  (drugsState) => drugsState.latestSuccessfullAction,
);
export const selectDrugsInStore = createSelector(selectDrugsState, (drugsState) => {
  const items = (drugsState.ids as number[])
    .map((id) => drugsState.entities[id])
    .filter((item): item is Drug => item !== undefined);
  return new QueryResultsModel(items, drugsState.totalCount);
});

export const selectDrugsShowInitWaitingMessage = createSelector(
  selectDrugsState,
  (drugsState) => drugsState.showInitWaitingMessage,
);

export const selectHasDrugsInStore = createSelector(selectDrugsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
